var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back-btn",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('q-icon',{attrs:{"name":"fas fa-chevron-left","color":"primary","size":"20px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }